export default __webpack_public_path__ + "static/media/metamask-new-custom-network-highlight.1c43fa37.png";